import { jsx as _jsx } from "react/jsx-runtime";
import { UsersList } from '@widgets/usersList';
export function UsersPage() {
    return (_jsx("div", { children: _jsx(UsersList, {}) }));
}
